module.exports = __webpack_public_path__ + "static/specializedinfrastructure-14bead7e8c1e8a3cf77357f934baa87f.svg";